import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

document.addEventListener('DOMContentLoaded', () => {
  const appDiv = document.querySelector('#root_calculator')
  if (appDiv) {
    const root = createRoot(appDiv)
    root.render(<App />)
  }
})
